export default __webpack_public_path__ + "static/media/mapCanvas.c0035486.js";